module.exports = __webpack_public_path__ + "static/banner-3c506f56c63d880cd68775ba22ccd14b.jpg";